'use client';

import * as React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ThemeProviderWrapper } from './theme';
import { ThirdwebProvider } from 'thirdweb/react';
import { VersionCheckProvider } from '../hooks/useVersionCheck';
import { VersionUpdatePopup } from '../components/VersionUpdatePopup';
import { DeviceApprovalProvider } from './device-approval-provider';
import { AlertProvider } from './alert-provider';
import { SessionProvider } from '../hooks/useSession';
import { OnchainKitWrapper } from './onchainkit-provider';

// Create a client outside the component to avoid recreating on every render
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60 * 1000, // 1 minute
      refetchOnWindowFocus: false,
    },
  },
});

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <QueryClientProvider client={queryClient}>
      <SessionProvider>
        <OnchainKitWrapper>
          <ThirdwebProvider>
            <VersionCheckProvider>
              <AlertProvider>
                <DeviceApprovalProvider>
                  <ThemeProviderWrapper>
                    {children}
                    <VersionUpdatePopup />
                  </ThemeProviderWrapper>
                </DeviceApprovalProvider>
              </AlertProvider>
            </VersionCheckProvider>
          </ThirdwebProvider>
        </OnchainKitWrapper>
      </SessionProvider>
    </QueryClientProvider>
  );
}
